import axiosInstance from "@/api/services/axios-instance";

export abstract class ApiService {

  static async ping(): Promise<void> {
    const url = `/api/ping`;
    await axiosInstance.get<void>(url, );
  }
}
